.page {
  --_gap: var(--s-7);
  display: flex;
  flex-direction: column;
  gap: var(--_gap);
  width: 100%;
  min-width: 0;
  padding: var(--s-8);
}
.page[data-width="content"] {
  max-width: calc(var(--content-max) + 2 * var(--s-8));
}
.page[data-width="narrow"] {
  max-width: calc(var(--w-narrow) + 2 * var(--s-8));
  margin-inline: auto;
}
.page[data-gap="sm"] {
  --_gap: var(--s-5);
}
.page[data-gap="lg"] {
  --_gap: var(--s-9);
}
.page[data-flush] {
  padding: 0;
}
@media (max-width: 767px) {
  .page {
    padding: var(--s-6);
  }
  .page[data-width="content"],
  .page[data-width="narrow"] {
    max-width: none;
  }
  .page[data-flush] {
    padding: 0;
  }
}
